<template>
  <div class="top-spacer"></div>
  <div class="news-detail">
    <div class="container">
      <div class="back-btn">
        <a href="javascript:history.back()">← 返回</a>
      </div>
      <div class="cover" v-if="article.cover">
        <img :src="article.cover" :alt="article.title">
      </div>
      <h1 class="title">{{ article.title }}</h1>
      <time class="publish-time">{{ formatDate(article.date) }}</time>
      <div class="content">
        <p v-for="(paragraph, index) in article.content.split('\n')" :key="index">
          {{ paragraph }}
        </p>
      </div>
      <img style="width:100%" src="@/images/u435.png" alt="">
      
      <h1 class="title">规格参数：</h1>
      <Table />
      <h1 class="title">产品竞争优势：</h1>
      <ul>
        <li>可检测的速度快 </li>
<li>检测物尺寸范围广</li>
<li>可精准识别</li>
      </ul>

    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Table from '@/components/Table/WholePieceReadcodeTable.vue'

const article = ref({
  id: 1,
  title: '整件读码设备',
  date: '2025-06-29',
  cover: require("@/images/u47.png"), 
  content: `在产品整件出入库时，对69码、监管码、UDI等信息进行扫码识别，通过系统对接，实现对订单/入库单的产品、批号、监管码、UDI等信息比对后结果回传。提高准确率，减少人员成本，提升整体出入库效率。`
})

function formatDate(dateString) {
  const date = new Date(dateString)
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

defineExpose({ formatDate })
</script>

<style scoped>
.top-spacer {
  height: 80px;
  width: 100%;
}

.news-detail {
  background-color: #f8f9fa;
  padding: 40px 20px;
  min-height: 100vh;
  font-family: 'Segoe UI', sans-serif;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 30px;
}

.back-btn {
  margin-bottom: 20px;
}

.back-btn a {
  text-decoration: none;
  color: #007bff;
  font-size: 14px;
}

.cover {
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 20px;
}

.cover img {
  width: 100%;
  height: auto;
  display: block;
}

.title {
  font-size: 28px;
  margin-bottom: 10px;
  color: #333;
}

.publish-time {
  display: block;
  color: #777;
  margin-bottom: 20px;
  font-size: 14px;
}

.content {
  line-height: 1.8;
  font-size: 16px;
  color: #555;
}

.content p {
  margin-bottom: 1em;
}
</style>